import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

// MUI Components
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import {Typography} from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

// Styled Components
import {StyledCard} from 'components/auth-error/styled';

// REDUX
import {connect} from 'react-redux';
import {rightsSelector} from 'redux/slices/appSlice';
import {useState} from 'react';
import {useEffect} from 'react';

const PageNotFound = ({rights}) => {
  const [path, setPath] = useState('');

  useEffect(() => {
    if (!rights.search && rights.reports) {
      setPath('/reports');
    } else {
      setPath('/');
    }
  }, [rights]);

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
      style={{marginTop: 70, textAlign: 'center'}}
    >
      <StyledCard style={{padding: 24}}>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Typography variant="h6">404 Page not found</Typography>
        </Grid>

        <Grid container direction="column" justifyContent="center" alignItems="center">
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Button component={Link} to={path} variant="contained" color="primary" style={{marginTop: 24}}>
              Home
              <OpenInNewIcon style={{width: 18, marginLeft: 8}} />
            </Button>
          </Grid>
        </Grid>
      </StyledCard>
    </Grid>
  );
};

PageNotFound.propTypes = {
  rights: PropTypes.object
};

const mapStateToProps = (state) => ({
  rights: rightsSelector(state)
});

export default connect(mapStateToProps)(PageNotFound);
